import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { useLayoutCustomizations, useUiParameters } from '@queries';
import { activityAtom } from '@store';

export const useKeyParameter = () => {
    const { data: parameters } = useUiParameters();
    const activity = useAtomValue(activityAtom);
    const { data: customizations } = useLayoutCustomizations(activity?.layoutId || -1);

    const customization = useMemo(
        () => customizations?.find((c) => c.parentUiNodeId === 'activity_navigation.default'),
        [customizations],
    );

    const keyParameterNode = useMemo(() => {
        return parameters?.find((node) => node.id === customization?.childUiNodeId, []);
    }, [customization?.childUiNodeId, parameters]);

    return keyParameterNode;
};
